import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    badge: 'items-center gap-1 text-xs c-grey-20 uppercase i-flex'
  }
} satisfies RecursivePartial<ProductConfig['badge']>
